import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { loadTranslations } from '@angular/localize';
import {
	SupportedLocales,
	DcBaseInitializationService,
} from '@datachain/ui-sdk/common';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { Datachain } from './app/core/constants';
import { loadMessages, locale } from 'devextreme/localization';
import frMessages from 'devextreme/localization/messages/fr.json';

import adbUiFrMessages from '@datachain/ui-sdk/assets/locale/messages.fr-FR.json';
import adbUiEnMessages from '@datachain/ui-sdk/assets/locale/messages.en-US.json';

async function start(): Promise<void> {
	await fetchConfigurations();
	await fetchTranslations();
}

async function fetchConfigurations(): Promise<void> {
	return new Promise((resolve, reject) => {
		fetch('/service/private/apiPaths')
			.then((response) => response.json())
			.then((paths) => {
				const config = DcBaseInitializationService.getConfigInstance();
				DcBaseInitializationService.updateConfig(
					config.setAvailableResources(paths)
				);
				setTimeout(resolve, 100);
			});
	});
}

async function fetchTranslations(): Promise<void> {
	const usedLangLocale = getLocale();
	const config = DcBaseInitializationService.getConfigInstance();
	DcBaseInitializationService.updateConfig(config.setLangLocal(usedLangLocale));

	let adbUiMessages = adbUiEnMessages.translations;
	if (usedLangLocale === SupportedLocales.Fr) {
		loadMessages(frMessages);
		locale(usedLangLocale);
		adbUiMessages = adbUiFrMessages.translations;
	}

	fetch(`${environment.localePath}/messages.${usedLangLocale}.json`)
		.then((response) => {
			return response.json();
		})
		.then((translationJson) => {
			const translation = translationJson['translations'];
			const _tra = { ...translation, ...adbUiMessages };
			if (translation) {
				loadTranslations(_tra);
			}
		})
		.catch((err) => {
			console.error(err);
		});
}

function getLocale(): string {
	const saved = localStorage.getItem(Datachain.CachedLang);
	return saved === null || saved === undefined
		? SupportedLocales.Fr
		: parseLang(saved);
}

function parseLang(langKey: string): string {
	switch (langKey) {
		case 'en':
			return SupportedLocales.En;
		case 'fr':
			return SupportedLocales.Fr;
		case 'browser': {
			const lang: string =
				navigator.language || (navigator as any).userLanguage;

			if (lang === 'fr-FR' || lang === 'fr') {
				return SupportedLocales.Fr;
			}
			if (lang === 'en-US' || lang === 'en') {
				return SupportedLocales.En;
			}
			break;
		}
	}
	return SupportedLocales.Fr;
}

function runApp(): void {
	platformBrowserDynamic()
		.bootstrapModule(AppModule)
		.catch((err) => console.error(err));
}

start().then(runApp, (err) => console.error(err));
